import { Typography } from '@mui/material';
import { OutlinedButton } from '@components/buttons';
import PaperContainer from '@components/containers/paper-container';
import { ReactNode } from 'react';
import { Gap } from '@components/layout-util-components/gap';

export interface OnboardingEntryContainerProps {
  icon: ReactNode;
  title: ReactNode;
  message?: ReactNode;
  createMessage?: ReactNode;
  onCreateClicked?: () => void;
  compact?: boolean;
  dark?: boolean;
}

export default function OnboardingEntryContainer({
  icon,
  title,
  message,
  createMessage,
  onCreateClicked,
  compact,
  dark,
}: OnboardingEntryContainerProps) {
  return (
    <PaperContainer
      sx={({ palette }) => ({
        padding: compact ? '20px !important' : undefined,
        backgroundColor: dark ? palette.common.grey15 : undefined,
      })}
    >
      {icon}
      <Gap size={32} />
      <Typography variant="h1" component="p">
        {title}
      </Typography>
      {message && (
        <>
          <Gap size={20} />
          <Typography variant="body1">{message}</Typography>
        </>
      )}
      {!!createMessage ? (
        <>
          <Gap size={32} />
          <OutlinedButton onClick={onCreateClicked}>
            {createMessage}
          </OutlinedButton>
        </>
      ) : null}
    </PaperContainer>
  );
}
